import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header>
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <a href="/" title="RS Transports">
            <img src="/images/logo_rstransports.jpg" alt="RS Transports Logo" />
          </a>
        </div>

        {/* Numéro de téléphone */}
        <div className="phone">
          <a href="tel:+33668160842" title="Call us">
            <FontAwesomeIcon icon={faPhone} className="phone-icon" /> 00 33 6 68 16 08 42
          </a>
        </div>

        {/* Hamburger Menu */}
        <button
          className="hamburger"
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation menu"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        {/* Navigation */}
        <nav className={`navigation ${isMenuOpen ? "active" : ""}`}>
          <ul>
            <li><a href="/" className="nav-link">Home</a></li>
            <li><Link to="/cars" className="nav-link" onClick={toggleMenu}>Cars</Link></li>
            <li><Link to="/rates" className="nav-link" onClick={toggleMenu}>Rates</Link></li>
            <li><Link to="/services" className="nav-link" onClick={toggleMenu}>Services</Link></li>
            <li><Link to="/info" className="nav-link" onClick={toggleMenu}>Info</Link></li>
            <li><Link to="/rates" className="nav-link" onClick={toggleMenu}>Reservation</Link></li>
            <li><Link to="/links" className="nav-link" onClick={toggleMenu}>Links</Link></li>
            <li><a href="https://rs-limousineparis.com/" className="nav-link">VIP Service</a></li>
            <li><Link to="Contact" className="nav-link" onClick={toggleMenu}>Contact</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
